/* eslint-disable react-hooks/exhaustive-deps */
import { gql, useLazyQuery } from '@apollo/client';
import { Box, Button, Center, Container, Divider, Flex, SimpleGrid, Stat, StatGroup, StatHelpText, StatLabel, StatNumber, Text } from '@chakra-ui/react';
import DateRangePicker from '@cloudscape-design/components/date-range-picker';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import BreadcrumbComponent from '../../../components/BreadcrumbComponent/BreadcrumbComponent';
import c from '../../../constant';

const QUERY_DATA = gql`
	query get($toDate: DateTime, $fromDate: DateTime) {
		getAgentStatistic(startDate: $fromDate, endDate: $toDate)
	}
`;

export default function AgentStatisticReport({ isModal }) {
	const { t } = useTranslation();
	const [pickedDateRange, setPickedDateRange] = React.useState(undefined);
	const [loadData, { loading, data }] = useLazyQuery(QUERY_DATA);

	useEffect(() => {
		loadData();
	}, []);

	useEffect(() => {
		if (pickedDateRange) {
			loadData({
				variables: {
					fromDate: moment(pickedDateRange?.startDate).toDate(),
					toDate: moment(pickedDateRange?.endDate).toDate(),
				},
			});
		} else {
			loadData();
		}
	}, [pickedDateRange]);

	function getHeader() {
		return (
			<Flex className="table-header" direction={'row'} alignItems={'center'}>
				<Flex flexGrow={1} className="title"></Flex>
				<Flex direction={'row'}>
					<FilterByDateRange />
					{!isModal && (
						<Button
							ml="10px"
							onClick={() => window?.print()}
							leftIcon={<FontAwesomeIcon icon={faPrint} style={{ fontSize: 16 }} />}
							colorScheme="gray"
							variant="solid"
							size="sm"
							borderRadius={c.borderRadius}
							border="1px solid #bdc3c7"
						>
							{t('Print')}
						</Button>
					)}
				</Flex>
			</Flex>
		);
	}
	// end table config

	function FilterByDateRange() {
		console.log('pickedDateRange:', pickedDateRange);
		return (
			<DateRangePicker
				onChange={({ detail }) => setPickedDateRange(detail.value)}
				value={pickedDateRange}
				rangeSelectorMode="absolute-only"
				placeholder="Filter by a date and time range"
				i18nStrings={{ applyButtonLabel: 'Apply', clearButtonLabel: 'Clear' }}
				absoluteFormat="long-localized"
				showClearButton={true}
				dateOnly={true}
			/>
		);
	}

	return (
		<>
			<Container maxW="container.xl" mt="16px" mb="16px">
				{!isModal && (
					<BreadcrumbComponent
						list={[
							{
								name: 'Settings',
								path: '/settings',
							},
							{
								name: 'Agent Statistic Report',
								path: '#',
							},
						]}
					/>
				)}

				<Center mt="5">
					<Box
						w="100%"
						bg="white"
						borderRadius={c.borderRadius}
						border="1px solid #dbdbdb"
						boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)"
						pb="32px"
					>
						<Box p="4" w="100%" maxW={'8xl'} mt="5">
							{getHeader()}
							{loading && <Text>{t('Loading')}</Text>}
							{!loading && (
								<>
									{data?.getAgentStatistic && (
										<StatGroup mt="4">
											<SimpleGrid w="100%" columns={[2, null, 3]} spacing="40px">
												<Stat>
													<StatLabel>Total Insurance Agent Registration</StatLabel>
													<StatNumber>{data?.getAgentStatistic?.totalInsuranceRegistration}</StatNumber>
													<StatHelpText>{`(${t('Male')}: ${data?.getAgentStatistic?.totalInsuranceRegistrationMale} ${t('Female')}: ${data?.getAgentStatistic?.totalInsuranceRegistrationFemale})`}</StatHelpText>
												</Stat>

												<Stat>
													<StatLabel>Approved Registration</StatLabel>
													<StatNumber>{data?.getAgentStatistic?.countApprovedRegistration}</StatNumber>
													<StatHelpText>{`(${t('Male')}: ${data?.getAgentStatistic?.countApprovedRegistrationMale} ${t('Female')}: ${data?.getAgentStatistic?.countApprovedRegistrationFemale})`}</StatHelpText>
												</Stat>

												<Stat>
													<StatLabel>Rejected Registration</StatLabel>
													<StatNumber>{data?.getAgentStatistic?.countRejectRegistration}</StatNumber>
													<StatHelpText>{`(${t('Male')}: ${data?.getAgentStatistic?.countRejectRegistrationMale} ${t('Female')}: ${data?.getAgentStatistic?.countRejectRegistrationFemale})`}</StatHelpText>
												</Stat>

												<Stat>
													<StatLabel>Agent Card Provided (New Code)</StatLabel>
													<StatNumber>{data?.getAgentStatistic?.countActiveRegistration}</StatNumber>
													<StatHelpText>{`(${t('Male')}: ${data?.getAgentStatistic?.countActiveRegistrationMale} ${t('Female')}: ${data?.getAgentStatistic?.countActiveRegistrationFemale})`}</StatHelpText>
												</Stat>

												<Stat>
													<StatLabel>Expired Card</StatLabel>
													<StatNumber>{data?.getAgentStatistic?.countExpiredRegistration}</StatNumber>
													<StatHelpText>{`(${t('Male')}: ${data?.getAgentStatistic?.countExpiredRegistrationMale} ${t('Female')}: ${data?.getAgentStatistic?.countExpiredRegistrationFemale})`}</StatHelpText>
												</Stat>
											</SimpleGrid>
										</StatGroup>
									)}
									<Divider />
									{data?.getAgentStatistic && (
										<StatGroup mt="4">
											<SimpleGrid w="100%" columns={[2, null, 3]} spacing="40px">
												<Stat>
													<StatLabel>Total Renewal Submitted</StatLabel>
													<StatNumber>{data?.getAgentStatistic?.totalRenewalSubmitted}</StatNumber>
													<StatHelpText>{`(${t('Male')}: ${data?.getAgentStatistic?.totalRenewalSubmittedMale} ${t('Female')}: ${data?.getAgentStatistic?.totalRenewalSubmittedFemale})`}</StatHelpText>
												</Stat>

												<Stat>
													<StatLabel>Approved Renewal</StatLabel>
													<StatNumber>{data?.getAgentStatistic?.countApprovedRenewal}</StatNumber>
													<StatHelpText>{`(${t('Male')}: ${data?.getAgentStatistic?.countApprovedRenewalMale} ${t('Female')}: ${data?.getAgentStatistic?.countApprovedRenewalFemale})`}</StatHelpText>
												</Stat>

												<Stat>
													<StatLabel>Paid Renewal</StatLabel>
													<StatNumber>{data?.getAgentStatistic?.coundPaidRenewal}</StatNumber>
													<StatHelpText>{`(${t('Male')}: ${data?.getAgentStatistic?.coundPaidRenewalMale} ${t('Female')}: ${data?.getAgentStatistic?.coundPaidRenewalFemale})`}</StatHelpText>
												</Stat>

												<Stat>
													<StatLabel>Rejected Renewal</StatLabel>
													<StatNumber>{data?.getAgentStatistic?.countRejectedRenewal}</StatNumber>
													<StatHelpText>{`(${t('Male')}: ${data?.getAgentStatistic?.countRejectedRenewalMale} ${t('Female')}: ${data?.getAgentStatistic?.countRejectedRenewalFemale})`}</StatHelpText>
												</Stat>
											</SimpleGrid>
										</StatGroup>
									)}
								</>
							)}
						</Box>
					</Box>
				</Center>
			</Container>
		</>
	);
}
